"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalToMatcherContext = void 0;
function equalToMatcherContext(ruleAttr) {
    return function equalToMatcher(runtimeAttr) {
        var isEqual = runtimeAttr === ruleAttr;
        return isEqual;
    };
}
exports.equalToMatcherContext = equalToMatcherContext;
